<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Ride Activity</span>
      @if (!isClient) {
        <span class="text-light-color text-base font-normal">#{{ config.data.id }}</span>
      }
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<app-tabs [initialTabIndex]="0">
  @if (appSetting.viewNoteActivityLog) {
    <app-tab tabTitle="Notes">
      <div class="flex flex-column gap-spacing-xl">
        <app-notes [data]="notes()"></app-notes>
        <div class="new-note-section pb-2">
          <div class="flex flex-column gap-spacing-xs">
            <div class="form-group textarea-container relative">
              <textarea
                rows="5"
                cols="30"
                #noteInput="ngModel"
                [(ngModel)]="note"
                maxlength="500"
                pTextarea
                [autoResize]="true"
                placeholder="Type note here...">
              </textarea>
              <div class="btn-container">
                <app-button
                  (btnClick)="addNote()"
                  [disabled]="!note || loading"
                  label="Add"
                  sizeClass="p-button-sm"
                  severity="primary"></app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-tab>
  }

  @if (appSetting.viewActivityLog) {
    <app-tab tabTitle="Activity Log">
      <div class="table-section">
        <h6 class="text-sm">Activity Log</h6>
        <app-basic-table
          [tableData]="activityLogTableData()"
          [showIndex]="true"></app-basic-table>
      </div>
    </app-tab>
  }

  @if (appSetting.viewStopsActivityLog) {
    <app-tab tabTitle="Waypoints">
      <div class="waypoints-section">
        <p-accordion
          class="w-full"
          (valueChange)="accordionActiveIndexChange($event)"
          [value]="accordionActiveIndex">
          @for (stop of this.config.data.rideTimeline; let i = $index; track $index) {
            <p-accordion-panel
              [value]="i"
              class="p-accordion-tab-element">
              <p-accordion-header>
                <div
                  class="relative header-wrapper w-full"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation()">
                  <div
                    #headerRef
                    [ngClass]="{ open: accordionActiveIndex == i, done: stop.statusType == 'Visited' }"
                    class="stop w-full active flex justify-content-between gap-spacing-xs align-items-start">
                    <div class="left flex gap-spacing-md align-items-center">
                      <div class="badge-container relative">
                        <app-badge
                          [pTooltip]="stop.active ? tooltipContent : ''"
                          tooltipPosition="bottom"
                          [autoHide]="false"
                          [value]="(i + 1).toString()"
                          size="xlarge"
                          [severityClass]="stop.color">
                        </app-badge>
                        <span class="h-line"></span>

                        <ng-template #tooltipContent>
                          <app-ride-timeline-tooltip [stop]="stop"></app-ride-timeline-tooltip>
                        </ng-template>
                      </div>
                      <span class="time min-w-max text-base font-medium text-secondary-color">{{ stop.time }}</span>
                      <span class="passengers-number min-w-max text-base font-medium"> <i class="icon-users-solid"></i> {{ stop.cargoes?.length }} </span>
                    </div>

                    <div class="right gap-spacing-4xl flex justify-content-between align-items-center">
                      @if (stop.statusType) {
                        <app-tag
                          styleClass="bold"
                          [content]="stop.statusType"
                          sizeClass="tag-sm"
                          [severityClass]="stop.color"></app-tag>
                      }
                      <div class="action-btns flex gap-spacing-xs align-items-center">
                        <div>
                          <app-button
                            (btnClick)="setRideStopMenuItems($event, stop, rideStopMenu, i)"
                            [iconOnlyButton]="true"
                            icon="icon-list"
                            sizeClass="p-button-sm"
                            severity="primary"
                            [outlinedButton]="true">
                          </app-button>
                          <p-menu
                            styleClass="ride-stop-menu"
                            [appendTo]="'body'"
                            #rideStopMenu
                            [model]="rideStopMenuItems()"
                            [popup]="true" />
                        </div>
                        <app-button
                          (btnClick)="toggleActiveAccordionTab(i)"
                          [iconOnlyButton]="true"
                          [icon]="accordionActiveIndex == i ? 'icon-caret-up' : 'icon-caret-down'"
                          sizeClass="p-button-sm"
                          severity="primary"
                          [outlinedButton]="true"></app-button>
                      </div>
                    </div>
                  </div>
                </div>
              </p-accordion-header>

              <p-accordion-content>
                <div class="content relative flex flex-column gap-spacing-md">
                  <span class="h-line"></span>
                  <div class="location px-spacing-md">
                    <div class="place flex align-items-center gap-spacing-xs">
                      @if (stop.placeType == "School") {
                        <i class="icon-building-office-solid text-base text-lightest-color"></i>
                      } @else {
                        <img
                          src="assets/images/house-5 1.svg"
                          alt="" />
                      }
                      <span class="name text-base font-medium text-primary-color">{{ stop.place }}</span>
                    </div>
                    <div class="map-location flex align-items-center gap-spacing-xs">
                      <i class="icon-map-pin-solid text-base text-link-color"></i>
                      <a class="link no-underline text-base font-normal text-link-color">{{ stop.address }}</a>
                    </div>
                  </div>

                  <div class="passengers flex flex-column gap-spacing-md pb-spacing-xl">
                    @for (passenger of stop.cargoes; track $index) {
                      <div
                        #passengerRef
                        class="passenger px-spacing-md py-spacing-xs bg-white flex justify-content-between gap-spacing-xs border-round-md shadow-1">
                        <div class="left flex align-items-center gap-spacing-xs">
                          @if (passenger.actionType.toLowerCase() == cargoActionType().PickUp.toLowerCase()) {
                            <img
                              src="assets/images/person-plus-fill 1.svg"
                              alt="" />
                          } @else if (passenger.actionType.toLowerCase() == cargoActionType().DropOff.toLowerCase()) {
                            <img
                              src="assets/images/person-dash-fill 1.svg"
                              alt="" />
                          }
                          <span class="name text-base font-medium line-height-3 text-primary-color">
                            {{ passenger.name }}
                          </span>
                          <app-tag
                            [content]="passenger.type"
                            sizeClass="tag-sm"
                            severityClass="secondary"></app-tag>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>
      </div>
    </app-tab>
  }

  @if (appSetting.viewGPSPingsData) {
    @if (GPSPingsData().data.length > 0) {
      <app-tab tabTitle="GPS Pings">
        <div class="table-section">
          <h6 class="text-sm">GPS Pings</h6>
          <app-basic-table
            [tableData]="GPSPingsData()"
            [showIndex]="false"></app-basic-table>
        </div>
      </app-tab>
    } @else {
      <app-tab tabTitle="GPS Pings">
        <app-no-records></app-no-records>
      </app-tab>
    }
  }
</app-tabs>

<div class="p-dialog-footer footer pt-spacing-3xl px-0">
  <app-button
    label="Close"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
</div>
